<div class="row text-center animate__animated animate__fadeIn">
    <div class="col">
        <span class="loader"></span>
    </div>
</div>